<template>
  <div class="login-box">
    <div class="login-main-box">
      <div>
        <div style="width: 120px; height: 120px">
          <img src="../../../assets/images/loginIMG.png"
               style="border-radius: 50%"
               alt />
        </div>
        <!-- <van-row class="login-title">
          <van-col span="24">登录账号</van-col>
        </van-row>
        <van-row class="login-main">
          <van-col span="24"></van-col>
        </van-row>-->
      </div>

      <van-row class="login-bottom">
        <van-col span="24">
          <van-button :loading="loading"
                      block
                      icon="wechat"
                      type="primary"
                      size="large"
                      plain
                      round
                      @click="onSubmit">
            确定</van-button>
          <van-button style="margin-top: 20px"
                      :loading="loading"
                      v-if="IsTest"
                      type="default"
                      size="small"
                      @click="onTestSubmit">使用测试账号登录v1.0</van-button>
        </van-col>
      </van-row>
      <van-dialog v-model="IsShow"
                  showCancelButton
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  confirm-button-color="#ee0a24"
                  @confirm="confirm(password)">
        <div class="passWordField">
          <van-field label-width="20vw"
                     v-model="password"
                     placeholder="请输入密码"
                     clearable
                     label="密码"
                     :value="password">
          </van-field>
        </div>
      </van-dialog>
      <van-dialog v-model="IsLoginShow"
                  showCancelButton
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  confirm-button-color="#ee0a24"
                  @confirm="confirmButton(password1)">
        <div class="passWordField">
          <van-field label-width="20vw"
                     v-model="password1"
                     placeholder="请输入密码"
                     clearable
                     label="密码"
                     :value="password1">
          </van-field>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Field,
  Button,
  Notify,
  Dialog,
  Toast,
} from "vant";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/redirect/index";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Notify.name]: Notify,
  },
  data () {
    return {
      password: "", //测试
      password1: "", //测试
      IsShow: false,
      IsLoginShow: false,
      phoneNumber: "",
      loading: false,
      IsTest: false,
      urlParmams: {},
      shareUrl: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo", "bankCardStatus", "agentShow"]),
  },
  methods: {
    ...mapActions(["wxLogin", "statusOut", "saveBankStatus", "buyAgentStatus"]),
    onSubmit () {
      //
      service.isDebugger().then((res) => {
        // false直接访问 true密码验证
        if (res.data == true) {
          this.IsLoginShow = true;
        } else {
          let redirectUrl = this.$route.query.redirect || "/";
          console.log(
            "https://" + window.location.host + "/redirect",
            redirectUrl,
            98
          );
          // this.$router.push({
          //   path: `/redirect?state=${redirectUrl}&code=031jRHFa1qnmXz0E0fJa1IUBlv4jRHFu`,
          // });
          // this.$router.push({
          //   path: `/redirect?state=${redirectUrl}&code=051sZEGa19KqsA08O1Ga1q6aKL0sZEGE`
          // });
          var redirect = "https://" + window.location.host + "/redirect";
          var redirect_uri = encodeURIComponent(redirect);
          let getShareUrl = JSON.parse(localStorage.getItem("shareUrl"));
          console.log(getShareUrl, "getShareUrl");
          // debugger
          if (
            getShareUrl.isShared !== null &&
            getShareUrl.isShared !== undefined &&
            getShareUrl.isShared !== ""
          ) {
            location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}?goodsId=${getShareUrl.goodsId}?shareUserId=${getShareUrl.shareUserId}?SharedType=${getShareUrl.SharedType}?isShared=true#wechat_redirect`;
            localStorage.removeItem("shareUrl");
          } else {
            location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}#wechat_redirect`;
            localStorage.removeItem("shareUrl");
          }
          // this.qrCode = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=login?goodsId=${this.$route.query.code}?shareUserId=${this.userInfo.userId}?SharedType=1?isShared=true#wechat_redirect`

          this.IsLoginShow = false;
        }
      });
    },
    // need password login
    confirmButton (password1) {
      // this.IsLoginShow = true;
      if (password1 == "1030win") {
        let redirectUrl = this.$route.query.redirect || "/";
        console.log(
          "https://" + window.location.host + "/redirect",
          redirectUrl,
          98
        );


        // this.$router.push({
        //   path: `/redirect?state=${redirectUrl}&code=031jRHFa1qnmXz0E0fJa1IUBlv4jRHFu`,
        // });
        // this.$router.push({
        //   path: `/redirect?state=${redirectUrl}&code=051sZEGa19KqsA08O1Ga1q6aKL0sZEGE`
        // });
        // 需求 判断公司关闭的情况下 内部工作人员依旧可以通过密码进入 
        var redirect = "https://" + window.location.host + "/redirect";
        // "https://testygw.m.taohuasanbao.com/redirect"
        var redirect_uri = encodeURIComponent(redirect);
        let getShareUrl = JSON.parse(localStorage.getItem("shareUrl"));
        console.log(getShareUrl, "getShareUrl");

        // debugger
        if (
          getShareUrl.isShared !== null &&
          getShareUrl.isShared !== undefined &&
          getShareUrl.isShared !== ""
        ) {
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}?goodsId=${getShareUrl.goodsId}?shareUserId=${getShareUrl.shareUserId}?SharedType=${getShareUrl.SharedType}?isShared=true#wechat_redirect`;
          localStorage.removeItem("shareUrl");
        } else {
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}#wechat_redirect`;
          localStorage.removeItem("shareUrl");
        }
        // console.log(webconfig.path,webconfig.path + "/redirect",redirect_uri,110)
        // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}#wechat_redirect`;
        // this.$router.push({
        // path: `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx467f0d80613ef115&redirect_uri=http%3A%2F%2Ftestygw.m.taohuasanbao.com%2Fredirect&response_type=code&scope=snsapi_userinfo&state=/#wechat_redirect`
        // });
        // https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx15e50dd7ea27661f&redirect_uri=http%3A%2F%2Fvideo.taomengyuan88.com%2Fredirect&response_type=code&scope=snsapi_userinfo&state=/#wechat_redirect

        // this.loading = true;
        // this.login({
        //   phoneNumber: this.phoneNumber,
        //   password: this.password,
        // })
        //   .then(() => {
        //     let redirectUrl = decodeURIComponent(
        //       this.$route.query.redirect || "/"
        //     );
        //     this.$router.push({
        //       path: redirectUrl,
        //     });
        //   })
        //   .catch((error) => {
        //     Notify({ type: "warning", message: error.data.errorMessage });
        //     this.loading = false;
        //   });
      } else {
        Toast("请输入正确的密码");
        this.IsLoginShow = true;
      }
    },
    // need password test  yan olV-ewXYgxgZVPwsU9b3gI6XDwI8  HAO 	oWMCL56oKevAbdFrUPXtH8PZ7S5Q   olV-ewbgtlck6wWlheh0a8xMw3vo  yu散户
    // 	oWMCL56oKevAbdFrUPXtH8PZ7S5Q win  olV-ewYz-WlKYpgjmoxvokYTSx_c  meng   olV-ewRZe0skSn7DOWn_qOjdDKs8  summer olV-ewURsp9lJp7QvfyXt82a2mw8 l olV-ewb8u4eHRIrG4KoxBfyITabg 伟
    // 测试
    // lhy 修改（此处为测试环境的登录）
    confirm (password) {
      if (password == "oWMCL56oKevAbdFrUPXtH8PZ7S5Q") {
        let redirectUrl = this.$route.query.redirect || "/";
        // console.log(window.wx,164)
        // var encode = '3248381845'
        // let encodeStr = Base64_encode(encode);
        // console.log(encodeStr, "encodeStr")
        // location.href = `https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0ODM4MTg0NQ==&scene=110#wechat_redirect`;

        // ==============lhy 修改  截取url 截取参数 来判断是否是通过分享二维码进入的==================
        // 获取当前 URL
        let url = window.location.href;
        // let url = new URL(window.location.href);

        // let params = new URLSearchParams(url.search);
        // 模拟 url
        // let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx467f0d80613ef115&redirect_uri=http://192.168.0.109:7293/&response_type=code&scope=snsapi_userinfo&state=login&goodsId=111111111111191&shareUserId=3991245047935795200&SharedType=1&isShared=true?#wechat_redirect'
        // let params = new URLSearchParams(url.search);
        if (url.indexOf("appid") > -1) {
          //  扫码登录
          let urlParmams = this.getUrlParams(url);
          console.log(urlParmams, "urlParmams");
          service
            .wxLoginTest(
              "oWMCL56oKevAbdFrUPXtH8PZ7S5Q",
              urlParmams.isShared,
              urlParmams.SharedType,
              urlParmams.goodsId,
              urlParmams.RaffleId
            )
            .then((res) => {
              this.wxLogin(res.data).then(() => {
                // debugger
                if (res.data.isShared === true && res.data.goodsId !== "") {
                  //调取个后端需要的接口 后端需要记录
                  if (res.data.sharedType == 1) {
                    this.urlParmams = {
                      code: "1",
                      shareUserId: urlParmams.shareUserId,
                      shareGoodsId: res.data.goodsId,
                      type: res.data.sharedType,
                    };
                  } else if (res.data.sharedType == 2) {
                    this.urlParmams = {
                      code: "1",
                      shareUserId: urlParmams.shareUserId,
                      shareGoodsId: res.data.goodsId,
                      type: res.data.sharedType,
                      raffleId: res.data.raffleId,
                    };
                  }
                  console.log(this.urlParmams, "记录参数");
                  this.postRecord(this.urlParmams);
                } else {
                  // 代买状态
                  // -----------原有代码---------------------
                  console.log(this.agentShow, 174);
                  this.buyAgentStatus({ show: false });
                  this.$log.debug("redirectUrl", redirectUrl);
                  this.$router.replace({
                    path: redirectUrl,
                  });
                  // -------------------------------
                }
              });
            });
        } else {
          // 正常登录
          service
            .wxLoginTest("oWMCL56oKevAbdFrUPXtH8PZ7S5Q", null, null, null, null)
            .then((res) => {
              this.wxLogin(res.data).then(() => {
                // 代买状态
                // -----------原有代码---------------------
                console.log(this.agentShow, 174);
                this.buyAgentStatus({ show: false });
                this.$log.debug("redirectUrl", redirectUrl);
                this.$router.replace({
                  path: redirectUrl,
                });
                // -------------------------------
              });
            });
        }
      } else {
        Toast("请输入正确的密码");
        this.IsShow = false;
      }
    },
    // lhy 截取参数函数
    getUrlParams (url) {
      let urlStr = url.split("?")[1];
      let obj = {};
      let paramsArr = urlStr.split("&");
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        let arr = paramsArr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj;
    },
    // isCheckDebugger (data) {
    //   service.isDebugger().then((res) => {
    //     // debugger
    //     // false直接访问 true密码验证
    //     if (res.data == true) {
    //       // 跳转登录页面并且显示 确定后的弹窗
    //       this.IsLoginShow = true;
    //       // this.$router.push({ name: "login" });
    //     } else {
    //       this.postRecord(data)
    //     }
    //   });
    // },
    //lhy 扫码记录接口 scanRecord
    postRecord (data) {
      // debugger
      console.log(data);
      service.scanRecord(data).then((res) => {
        if (res.data == true) {
          // 跳转用户绑定页面
          this.$router.push({
            name: "bind",
            query: { shareCode: res.shareCode },
          });
        } else {
          //跳转商品详情页
          this.$router.push({
            name: "goods",
            query: { code: this.urlParmams.goodsId, type: "1" },
          });
        }
      });
    },
    onTestSubmit () {
      this.IsShow = true;
    },
  },
  mounted () {
    // 根据url 不同 判断是正常登录还是分享登录
    this.shareUrl = window.location.href;
    console.log(this.shareUrl, " this.shareUrl");
    if (this.shareUrl.indexOf("?") > -1) {
      let urlParmams = this.getUrlParams(this.shareUrl);
      console.log(urlParmams, "urlParmams");
      localStorage.setItem("shareUrl", JSON.stringify(urlParmams));
    } else {
      let urlParmams = {};
      localStorage.setItem("shareUrl", JSON.stringify(urlParmams));
    }

    let obj = {
      color:
        this.bankCardStatus !== null && this.bankCardStatus.color
          ? this.bankCardStatus.color
          : 0,
    };
    // this.statusOut();
    console.log(webconfig.isDebugger, 159);
    service.isDebugger().then((res) => {
      // false直接访问 true密码验证
      if (res.data == true) {
        this.IsTest = true;
      }
    });
    this.saveBankStatus(obj);
  },
};
</script>

<style lang="less">
.login {
  &-box {
    position: fixed;
    width: 100%;
    bottom: 70px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &-close {
    font-size: 2em;
    color: #666;
  }

  &-close-box {
    text-align: right;
  }

  &-title {
    margin-top: 5%;
    font-size: 6.2vw;
    text-align: center;
  }

  &-main-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &-main {
    margin: 8% 0;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-bottom {
    height: 100px;
    width: 80vw;
    margin-top: 25vw;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
</style>
